var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","margin-bottom":"600px"}},[_vm._v("\n  智慧城市\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }